import { api } from '@/api/client';

export interface BrowserFolder {
  name: string;
  path: string;
}

export interface BrowserFile {
  key: string;
  url: string;
  filename: string;
  lastModified: string;
  size: number;
}

export interface RecentProject {
  name: string;
  path: string;
  photoCount: number;
  lastModified: string;
}

export async function fetchBrowse(prefix: string): Promise<{ folders: BrowserFolder[]; files: BrowserFile[] }> {
  return api<{ folders: BrowserFolder[]; files: BrowserFile[] }>(`/api/photos/browse?prefix=${encodeURIComponent(prefix)}`);
}

export async function deleteBrowserPhoto(key: string): Promise<void> {
  await api<void>(`/api/photos/browse?key=${encodeURIComponent(key)}`, { method: 'DELETE' });
}

export async function fetchRecentProjects(limit = 10): Promise<{ projects: RecentProject[] }> {
  return api<{ projects: RecentProject[] }>(`/api/photos/recent?limit=${limit}`);
}
